import { environment } from '@attain-apps/fe/web/main/env'
import { Amplify } from 'aws-amplify'
// TODO - Either keep it here or remove it once the analytics setup is underway
// import { record } from 'aws-amplify/analytics/kinesis-firehose'

const {
  auth: { userPoolClientId, userPoolId, providerUrl, identityPoolId },
  graphqlEndpoint,
} = environment

/**
 * Configures Amplify, which we use for authentication and GraphQL requests
 */
Amplify.configure({
  /* eslint-disable @typescript-eslint/naming-convention */
  API: {
    GraphQL: {
      defaultAuthMode: 'lambda',
      endpoint: graphqlEndpoint,
      region: 'us-east-1',
    },
  },
  Analytics: {
    KinesisFirehose: {
      region: 'us-east-1',
    },
  },
  Auth: {
    Cognito: {
      identityPoolId,
      loginWith: {
        oauth: {
          domain: providerUrl,
          redirectSignIn: [document.location.origin],
          redirectSignOut: [document.location.origin],
          responseType: 'code',
          scopes: ['openid'],
        },
      },
      userPoolClientId,
      userPoolId,
    },
  },
  /* eslint-enable @typescript-eslint/naming-convention */
})
/**
 * Track page views
 */
// TODO - This will be used for reference in future and should be removed or modified once we start creating a more concrete analytics setup
// function trackPageView() {
//   record({
//     data: {
//       title: document.title,
//       type: 'pageView',
//       url: window.location.href,
//     },
//     streamName: `attain-apps-sandbox`,
//   })
// }
// trackPageView()
